import isNumeric from '../../../../utils/is-numeric';

const parseValue = (rawValue, supportedUnits) => {
  const matchedUnit = supportedUnits.find((unit) => rawValue.endsWith(unit));

  if (matchedUnit) {
    const numericValue = Number(rawValue.slice(0, -matchedUnit.length));

    return {
      value: numericValue,
      unit: matchedUnit,
      isValid: isNumeric(numericValue),
    };
  }

  return {
    value: Number(rawValue),
    unit: '',
    isValid: isNumeric(Number(rawValue)),
  };
};

export default parseValue;
